module.exports = __webpack_public_path__ + "img/verification.ff2a606c.svg";